import React, { Component } from "react";
import { PostData } from "../../../service/postData";
import { sendNotification } from "../../../_notificationSettings/notificationPanel";
import ToggleSwitch from "../../../_toggleSwitch/toggleSwitch";
import validator from "validator";

import moment from "moment";
import DatePicker from "react-datepicker";
import Modal from "react-modal";
import QuickAddNewBankDetail from "./quickBankAdd";
import "bootstrap-daterangepicker/daterangepicker.css";

let _signingId = "0";
let _businessId = "0";
let _company_id = "0";
let country_code = "0";
let tax_name = "";
let gstTypeData = [];

let _countryCode = "IN";
let _UserSession = localStorage.getItem("vs_UserSession");
if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _company_id = _companySession.company_id;
  country_code = _companySession.country_code;
  tax_name = _companySession.tax_name;
  gstTypeData = _companySession.taxType;
  let bankArrayData = _companySession.bankDetails ? _companySession.bankDetails : [];
}

let _loader = "glb-ldr-prt active";
let _isEditMode = false;
export default class quickBankTransferPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedirectTo: this.props.isRedirectTo
        ? this.props.isRedirectTo
        : "business/manage-loan-accounts/",
      buttonTitle: "",
      hideShow: "",
      isLoaded: true,
      company_id: _company_id,
      businessId: _businessId,
      userId: _signingId,
      activeBankId: this.props.activeBankId ? this.props.activeBankId : 0,
      popType: this.props.popType,

      imagePreviewUrl: [],
      imgCollection: [],
      imgCollectionOld: [],
      transfer_date: moment().format("YYYY-MM-DD"),
      amount: "",
      deposit_to: "Cash",
      withdraw_from: "Cash",
      description: "",
      depositType: "",
      accountTrasactionId: this.props.accountTrasactionId ? this.props.accountTrasactionId : 0,
      bankDataSend : [],
      isBankLoading: true,

      bankId_W: 0, //'0',
      bankName_W: '',
      bankId_D: 0,
      bankName_D: '',
      bankId_AC: 0,
      bankName_AC: '',
      _bankIdAC: 0,

      adjust_type: "Increase",
      defaultBankId_W: "0",
      defaultBankId_D: "0",
      errors: {
        amount: "",
        deposit_to: "",
        withdraw_from: "",
        description: "",
      },
    };
    _isEditMode = this.props.accountTrasactionId > 0 ? true : false;
  }

  async componentDidMount() {
    let accountTrasactionId = this.props.accountTrasactionId;
    this.getBankAccListData();
   
    if (accountTrasactionId > 0) {
      const requestData = JSON.stringify({
        transferId: accountTrasactionId,
      });

      PostData(global.userBankTransferDetailsList, requestData, "POST")
        .then((result) => {
          let responseJson = result;
          if (responseJson.success == false) {
            this.setState({ isLoaded: true });
          } else {
            if (responseJson.response) {
              _isEditMode = true;
              let _transArray = responseJson.response[0];
              // For BTC/CTB, prefer adjust_bank_id: the edit endpoint always
              // sets it to the current bank, but older backend versions
              // (pre 2026-08-11) skipped updating bank_id_w/bank_id_d, so a
              // row edited to move A→B under old code still has bank_id_w=A.
              // Falling through to bank_id_w/bank_id_d handles freshly added
              // rows where adjust_bank_id=0. For BTB, both source/dest are
              // in bank_id_w/bank_id_d — read those directly.
              const _via = _transArray.via;
              let _bankId_W, _bankName_W, _bankId_D, _bankName_D;
              if (_via === 'BTC') {
                _bankId_W = _transArray.adjust_bank_id || _transArray.bank_id_w || 0;
                _bankName_W = _transArray.adjust_bank_name || _transArray.bank_name_w || '';
                _bankId_D = 0;
                _bankName_D = '';
              } else if (_via === 'CTB') {
                _bankId_D = _transArray.adjust_bank_id || _transArray.bank_id_d || 0;
                _bankName_D = _transArray.adjust_bank_name || _transArray.bank_name_d || '';
                _bankId_W = 0;
                _bankName_W = '';
              } else {
                _bankId_W = _transArray.bank_id_w || 0;
                _bankName_W = _transArray.bank_name_w || '';
                _bankId_D = _transArray.bank_id_d || 0;
                _bankName_D = _transArray.bank_name_d || '';
              }

              this.setState({
                buttonTitle: "Edit",
                bank_transction_id: _transArray.bank_transction_id,
                user_id: _transArray.user_id,
                business_id: _transArray.business_id,
                company_id: _transArray.company_id,
                transaction_type: _transArray.transaction_type,
                deposit_to: _transArray.deposit_to,
                withdraw_from: _transArray.withdraw_from,
                bankId_W: _bankId_W,
                bankName_W: _bankName_W,
                bankId_D: _bankId_D,
                bankName_D: _bankName_D,
                transfer_date: moment(_transArray.transfer_date).format("YYYY-MM-DD"),
                // Also treat empty-string '' as missing — the mobile app (and
                // any caller that bypasses the web form's client-side numeric
                // check) can save UserBankTransaction rows with amount=''.
                // The old `!= null` check let '' through, so the input rendered
                // blank on View/Edit ("amount is showing blank"). Fall back to
                // '0' so the field is always populated and editable.
                amount: (_transArray.amount === null || _transArray.amount === undefined || String(_transArray.amount).trim() === '') ? '0' : _transArray.amount,
                description: _transArray.description,
                adjust_type: _transArray.adjust_type,
                bankId_AC: _transArray.adjust_bank_id,
                bankName_AC: _transArray.adjust_bank_name,
                via: _transArray.via,
                defaultBankId_W: _bankId_W,
                defaultBankId_D: _bankId_D,
                imagePreviewUrl: _transArray.attach_image,
                depositType: _transArray.transaction_type,
                accountTrasactionId: this.props.accountTrasactionId,
                isLoaded: true,
              });
            }
          }
        })
        .catch((error) => this.setState({ error, isLoaded: false }));
    } else {
      _isEditMode = false;
      if (this.props.popType == "CTB") {
        this.setState({ depositType: "Deposit" });
      } else if (this.props.popType == "BTC") {
        this.setState({ depositType: "Withdraw" });
      }
    }
  }


  getBankAccListData() {
    let _bankArray = [];
    let _url_GetData =
      global.userBankDetailsList + "?company_id=" + this.state.company_id;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          this.setState({
            bankArray: _bankArray,
            isBankLoading: false,
          });
        } else {
          if (responseJson.response) {
            _bankArray = responseJson.response;
            if (responseJson.response) {
              _bankArray = responseJson.response;
              _bankArray.map((party, i) => {
                if (i == 0) {
                  _bankArray[i].isActiveClick = true;
                } else {
                  _bankArray[i].isActiveClick = false;
                }
              });
            }
          }
          // Only set default bank for NEW transactions (not edit mode)
          // In edit mode, bank selection comes from transaction details API
          if(_bankArray.length > 0 && !(this.props.accountTrasactionId > 0)){
            let firstBank = _bankArray.find(bank => bank.id > 0);
            if(firstBank){
              let _bankId1 = firstBank.id;
              let _bankName1 = firstBank.bank_name ? firstBank.bank_name : firstBank.display_name;
              this.setState({
                bankId_W: _bankId1,
                bankName_W: _bankName1,
                bankId_D: _bankId1,
                bankName_D: _bankName1,
                bankId_AC: _bankId1,
                bankName_AC: _bankName1,
              });
            }
          }
          this.setState({
            bankDataSend: _bankArray,
            isBankLoading: false,
          });
        }
      })
      .catch((error) => this.setState({ error, isBankLoading: false }));
  }

  handleCallBackDate = (start) => {
    this.setState({ transfer_date: start.format("YYYY-MM-DD") });
  };
  

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "amount":
        if (validator.isInt(value)) {
          errors.amount = "";
        } else {
          errors.amount = "*Amount should be numeric!";
        }
        this.setState({ amount: value });
        break;

      case "deposit_to":
        let _bankId = 0;
        let _bankName = "";
        let _wValue = "Cash";
        if (this.state.popType == "CTB") {
          if (value > 0) {
            _wValue = "Bank";
            var index = event.target.selectedIndex;
            var optionElement = event.target.childNodes[index];

            _bankId = optionElement.getAttribute("data-bankFromId");
            _bankName = optionElement.getAttribute("data-bankFromName");
            errors["deposit_to"] = "";
            this.setState({ errors: errors });
          }
          if (value == "NewBank") {
            this.openModalHandler("modalAdjustNewBank");
          }
        } else if (this.state.popType == "BTC") {
          _wValue = "Cash";

        } else if (this.state.popType == "BTB") {
          if (value > 0) {
            _wValue = "Bank";
            var index = event.target.selectedIndex;
            var optionElement = event.target.childNodes[index];

            _bankId = optionElement.getAttribute("data-bankFromId");
            _bankName = optionElement.getAttribute("data-bankFromName");
          }
          if (value == "NewBank") {
            this.openModalHandler("modalAdjustNewBank");
          }
        } else if (this.state.popType == "ADB") {
          _wValue = ""; // no need to define
        }

        if (
          this.state.bankId_W > 0 &&
          this.state.bankId_D > 0 &&
          this.state.popType == "BTB"
        ) {
          if (_bankId == this.state.bankId_W) {
            errors.deposit_to = "*Bank account should not be same!";
          } else {
            errors.deposit_to = "";
            errors.withdraw_from = "";
          }
        }

        this.setState({
          deposit_to: _wValue,
          bankId_D: _bankId,
          bankName_D: _bankName,
        });

        break;

      case "withdraw_from":
        let _bankIdW = 0;
        let _bankNameW = "";
        let _wValueW = "Cash";
        if (this.state.popType == "CTB") {
          _wValueW = "Cash";
        } else if (this.state.popType == "BTC") {
          if (value > 0) {
            _wValueW = "Bank";
            var index = event.target.selectedIndex;
            var optionElement = event.target.childNodes[index];

            _bankIdW = optionElement.getAttribute("data-bankFromIdW");
            _bankNameW = optionElement.getAttribute("data-bankNameW");
            errors["withdraw_from"] = "";
            this.setState({ errors: errors });
          }
          if (value == "NewBank") {
            _wValueW = "Bank";
            _bankIdW = this.state.bankDataSend[0].id;
            _bankNameW = this.state.bankDataSend[0].bank_name ? this.state.bankDataSend[0].bank_name : this.state.bankDataSend[0].display_name;
            this.openModalHandler("modalAdjustNewBank");
          }
        } else if (this.state.popType == "BTB") {
          if (value > 0) {
            _wValueW = "Bank";
            var index = event.target.selectedIndex;
            var optionElement = event.target.childNodes[index];

            _bankIdW = optionElement.getAttribute("data-bankFromIdW");
            _bankNameW = optionElement.getAttribute("data-bankNameW");
          }
          if (value == "NewBank") {
            this.openModalHandler("modalAdjustNewBank");
          }
        } else if (this.state.popType == "ADB") {
          _wValueW = ""; // no need to define
        }

        if (
          this.state.bankId_W > 0 &&
          this.state.bankId_D > 0 &&
          this.state.popType == "BTB"
        ) {
          if (_bankIdW == this.state.bankId_D) {
            errors.withdraw_from = "*Bank account should not be same!";
          } else {
            errors.withdraw_from = "";
            errors.deposit_to = "";
          }
        }

        this.setState({
          withdraw_from: _wValueW,
          bankId_W: _bankIdW,
          bankName_W: _bankNameW,
        });
        break;

      case "account_name":
        let _bankIdAC = 0;
        let _bankNameAC = "";
        let _wValueAC = "CASH";
        var index = event.target.selectedIndex;
        var optionElement = event.target.childNodes[index];

        if (this.state.popType == "ADB") {
          if (value > 0) {
            _wValueAC = "Bank";
            _bankIdAC = optionElement.getAttribute("data-bankADBId");
            _bankNameAC = optionElement.getAttribute("data-bankFromNameAC");
          }else{
            _bankIdAC = optionElement.getAttribute("data-bankADBId");
            _bankNameAC = optionElement.getAttribute("data-bankFromNameAC");
          }

          if (value == "NewBank") {
            this.openModalHandler("modalAdjustNewBank");
          }
        }
        this.setState({
          account_name: _wValueAC,
          bankId_AC: _bankIdAC,
          bankName_AC: _bankNameAC,
        });
        break;

      case "description":
        this.setState({ description: value });
        break;

      case "adjust_type":
        this.setState({ adjust_type: value });
        break;
      default:
        break;
    }
  };
  /*For Modal open close*/
  openModalHandler(e) {
    if (e == "modalAdjustNewBank") {
      this.setState({ modalIsOpen_SBANK: true });
    }
  }
  closeModalHandler = (e) => {
    if (e == "modalAdjustNewBank") {
      this.setState({ modalIsOpen_SBANK: false });
    }
  };
  /*End Modal open close*/

  clickToAddBankDetails = (event) => {
    event.preventDefault();
    let errors = this.state.errors;
    let _isError = false;

    //alert('aaa');return false;
    //alert(this.state.withdraw_from  + '==k=='+this.state.deposit_to );return false;

    if (this.state.received_in == "") {
      _isError = true;
      errors["received_in"] = "*Please Select Loan Received In";
      this.setState({ errors: errors });
    }

    if (this.state.amount == "") {
      _isError = true;
      errors["amount"] = "*Please Enter amount.";
      this.setState({ errors: errors });
    }
    if (
      (this.state.bankId_D == "0" || this.state.bankId_D == 0) &&
      this.state.depositType == "Deposit" &&
      this.state.deposit_to!="Cash"
    ) {
      _isError = true;
      errors["deposit_to"] = "*Please select any bank.";
      this.setState({ errors: errors });
    }
    if (
      (this.state.bankId_W == "0" || this.state.bankId_W == 0) &&
      this.state.depositType == "Withdraw" &&
      this.state.withdraw_from!="Cash"
    ) {
      _isError = true;
      errors["withdraw_from"] = "*Please select any bank 1.";
      this.setState({ errors: errors });
    }
    if (
      (this.state.bankId_D == "0" || this.state.bankId_D == 0) &&
      this.state.deposit_to!="Cash"
    ) {
      _isError = true;
      errors["deposit_to"] = "*Please select any bank.";
      this.setState({ errors: errors });
    }
    if((this.state.popType !="ADB" ) && (
      (this.state.bankId_W == "0" || this.state.bankId_W == 0) &&
      this.state.withdraw_from!="Cash" )
    ) {
      _isError = true;
      errors["withdraw_from"] = "*Please select any bank 2.";
      this.setState({ errors: errors });
    }
    if (
      this.state.bankId_W > 0 &&
      this.state.bankId_D > 0 &&
      this.state.popType == "BTB"
    ) {
      if (this.state.bankId_W == this.state.bankId_D) {
        _isError = true;
        errors["withdraw_from"] = "*Bank account should not be same!";
        errors["deposit_to"] = "*Bank account should not be same!";
        this.setState({ errors: errors });
      }
    }
    console.log("===EROORS===",this.state.errors);
    if (_isError == false) {
      if (this.props.accountTrasactionId > 0) {
        this.userEditMoneyTransferFun();
      } else {
        this.addBankTrasacDMethodCall();
      }
    }
  };

  onRadioChange = (e) => {
    let errors = this.state.errors;
    let _typeRadio = "BTC";
    errors["withdraw_from"] = "";
    errors["deposit_to"] = "";
    if (e.target.value == "Deposit") {
      _typeRadio = "CTB";
    }
    const currentPopType = this.state.popType;
    let newState = {
      depositType: e.target.value,
      popType: _typeRadio,
      errors: errors,
    };
    // Preserve the picked bank across a direction toggle. Without this,
    // editing a BTC (Withdraw) row and flipping to CTB (Deposit) leaves
    // bankId_W pointing at the original bank while bankId_D stays 0; the
    // backend's via='CTB' branch then persists adjust_bank_id=0 and
    // bank_id_d=0, orphaning the row from every bank-account view
    // (userallMoneyTransferList filters by bank_id_w/bank_id_d/
    // adjust_bank_id — all three zero means the row matches no bank).
    if (currentPopType === "BTC" && _typeRadio === "CTB") {
      newState.bankId_D = this.state.bankId_W;
      newState.bankName_D = this.state.bankName_W;
      newState.bankId_W = 0;
      newState.bankName_W = "";
      newState.deposit_to = "Bank";
      newState.withdraw_from = "Cash";
    } else if (currentPopType === "CTB" && _typeRadio === "BTC") {
      newState.bankId_W = this.state.bankId_D;
      newState.bankName_W = this.state.bankName_D;
      newState.bankId_D = 0;
      newState.bankName_D = "";
      newState.deposit_to = "Cash";
      newState.withdraw_from = "Bank";
    }
    this.setState(newState);
  };
  settleAmountType() {
    let _payData = [];
    if (this.state.isLoaded == true) {
      if (this.state.bankDataSend.length > 0) {
        this.state.bankDataSend.map((bankD, index) => {
          let _arrayLength = this.state.bankDataSend.length;
          let _valOption = bankD.paymentType;
          let _disOption = bankD.paymentType;
          let _isBankExist = 0;

          if (bankD.id > 0) {
            _isBankExist = 1;
            _valOption = bankD.id;
            _disOption = bankD.bank_name ? bankD.bank_name : bankD.display_name;
          }

          let _selBank = "";
          if (bankD.id > 0) {
            if (_valOption == this.state.bankId_W || _valOption == this.state.bankId) {
              _selBank = "selected";
            }
          } else {
            if (_valOption == this.state.paymentType) {
              _selBank = "selected";
            }
          }
          if (
            _valOption > 0 ||
            _disOption == "Cash" ||
            _disOption == "Cheque"
          ) {
            _payData.push(
              <option
                value={_valOption}
                selected={_selBank}
                data-bankName={_disOption}
                data-bankId={_valOption}
              >
                {_disOption}
              </option>
            );
          }
        });
        _payData.push(<option value="NewBank">Add New Bank </option>);
      } else if (this.state.isBankLoading) {
        _payData.push(<option value="">Loading Banks...</option>);
      } else {
        _payData.push(<option value="">Select Bank </option>);
        _payData.push(<option value="NewBank">Add New Bank</option>);
      }
    }
    return _payData;
  }

  settleAmountType_WAk() {
    let _payData = [];
    if (this.state.isLoaded == true) {
      if (this.state.bankDataSend.length > 0) {
        this.state.bankDataSend.map((bankD, index) => {
          let _arrayLength = this.state.bankDataSend.length;
          let _valOption = bankD.paymentType;
          let _disOption = bankD.paymentType;
          let _isBankExist = 0;

          if (bankD.id > 0) {
            _isBankExist = 1;
            _valOption = bankD.id;
            _disOption = bankD.bank_name ? bankD.bank_name : bankD.display_name;
          }

          let _selBank = "";
          if (bankD.id > 0) {
            if (_valOption == this.state.bankId_W) {
              _selBank = "selected";
            }
          } else {
            if (_valOption == this.state.paymentType) {
              _selBank = "selected";
            }
          }
          if (_valOption > 0 || _disOption == "Cash" || _disOption == "Cheque") {
            _payData.push(
              <option
                value={_valOption}
                selected={_selBank}
                data-bankNameW={_disOption}
                data-bankFromIdW={_valOption}
              >
                {_disOption}
              </option>
            );
          }
        });
        _payData.push(<option value="NewBank">Add New Bank </option>)
      } else if (this.state.isBankLoading) {
        _payData.push(<option value="0">Loading Banks...</option>)
      } else {
        _payData.push(<option value="0">Select Bank </option>)
        _payData.push(<option value="NewBank">Add New Bank</option>)
      }
    }
    return _payData;
  }


  settleAmountTypeDeposit() {
    let _payData = [];
    if (this.state.isLoaded == true) {
      if (this.state.bankDataSend.length > 0) {
        this.state.bankDataSend.map((bankD, index) => {
          let _arrayLength = this.state.bankDataSend.length;
          let _valOption = bankD.paymentType;
          let _disOption = bankD.paymentType;
          let _isBankExist = 0;

          if (bankD.id > 0) {
            _isBankExist = 1;
            _valOption = bankD.id;
            _disOption = bankD.bank_name ? bankD.bank_name : bankD.display_name;
          }

          let _selBank = "";
          if (_valOption == this.state.bankId_D) {
            _selBank = "selected";
          }
          if (_valOption > 0 || _disOption == "Cash" || _disOption == "Cheque") {
            _payData.push(
              <option
                value={_valOption}
                selected={_selBank}
                data-bankFromName={_disOption}
                data-bankFromId={_valOption}
              >
                {_disOption}
              </option>
            );
          }


          // let _addNewBank = "";
          // if (_arrayLength == index + 1) {
          //   if (_isBankExist == 0) {
          //   }
          // }
        });
        _payData.push(<option value="NewBank">Add New Bank </option>)
      } else if (this.state.isBankLoading) {
        _payData.push(<option value="0">Loading Banks...</option>)
      } else {
        _payData.push(<option value="0">Select Bank </option>)
        _payData.push(<option value="NewBank">Add New Bank</option>)
      }
    }

    return _payData;
  }

  settleAmountTypeADB() {
    let _payData = [];
    if (this.state.isLoaded == true) {
      if (this.state.bankDataSend.length > 0) {
        this.state.bankDataSend.map((bankD, index) => {
          let _arrayLength = this.state.bankDataSend.length;
          let _valOption = bankD.paymentType;
          let _disOption = bankD.paymentType;
          let _isBankExist = 0;

          if (bankD.id > 0) {
            _isBankExist = 1;
            _valOption = bankD.id;
            _disOption = bankD.bank_name ? bankD.bank_name : bankD.display_name;
          }

          let _selBank = "";
          if (bankD.id > 0) {
            if (_valOption == this.state.activeBankId) {
              _selBank = "selected";
            }
          } else {
            if (_valOption == this.state.paymentType) {
              _selBank = "selected";
            }
          }

          if (
            _valOption > 0 ||
            _disOption == "Cash" ||
            _disOption == "Cheque"
          ) {
            _payData.push(
              <option
                value={_valOption}
                selected={_selBank}
                // data-bankName={_disOption}
                data-bankFromNameAC={_disOption}
                data-bankADBId={_valOption}
              >
                {_disOption}
              </option>
            );
          }
        });
        _payData.push(<option value="NewBank">Add New Bank</option>);
      } else if (this.state.isBankLoading) {
        _payData.push(<option value="0">Loading Banks...</option>);
      } else {
        _payData.push(<option value="0">Select Bank </option>);
        _payData.push(<option value="NewBank">Add New Bank</option>);
      }
    }

    return _payData;
  }

  addBankTrasacDMethodCall() {
    let transaction_type = "";
    if (this.state.popType == "CTB") {
      transaction_type = "Deposit";
      if(this.state.bankId_D==0){
        alert('Please select correct Deposit To Bank');
        return false;
      }
    } else if (this.state.popType == "BTC") {
      transaction_type = "Withdraw";
      if(this.state.bankId_W == 0){
        alert('Please select correct Withdraw From Bank');
        return false;
      }
    }
    else if (this.state.popType == "ADB") {
      transaction_type = "Adjust Bank";
    }
    
    var saleData = new FormData();
    saleData.append("businessId", this.state.businessId);
    saleData.append("userId", this.state.userId);
    saleData.append("company_id", this.state.company_id);
    saleData.append("accountId", this.state.activeBankId);
    saleData.append("transaction_type", transaction_type);
    saleData.append("transfer_date", this.state.transfer_date);
    saleData.append("via", this.state.popType);
    saleData.append("deposit_to", this.state.deposit_to);
    saleData.append("withdraw_from", this.state.withdraw_from);
    saleData.append("amount", this.state.amount);
    saleData.append("bankId_AC", this.state.bankId_AC); 
    saleData.append("bankName_AC", this.state.bankName_AC);
    saleData.append("adjust_type", this.state.adjust_type);
    saleData.append("description", this.state.description);
    saleData.append("descImage", this.state.descImage);

    if(this.state.popType == "ADB"){
      saleData.append("bankId_W", 0);
      saleData.append("bankName_W","");
      saleData.append("bankName_D", "");
      saleData.append("bankId_D", 0);
      saleData.append("account_name", "");
    }else{
      saleData.append("bankId_W", this.state.bankId_W);
      saleData.append("bankName_W", this.state.bankName_W);
      saleData.append("bankName_D", this.state.bankName_D);
      saleData.append("bankId_D", this.state.bankId_D);
      saleData.append("account_name", this.state.account_name);
    }
    //return false;
    new Promise((resolve, reject) => {
      fetch(global.userAddMoneyTransfer, {
        method: "POST",
        body: saleData,
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success == true) {
            sendNotification("Success Message 👍", res.message, "success");
            setTimeout(() => {
              this.props.callBack("hello");
              //window.location.href = global.webUrl+'business/sale-invoice/';
            }, Math.floor(Math.random() * 5000) + 1);
          } else {
            sendNotification("Error Message 😓", res.message, "danger");
            return;
          }
        })
        .catch((error) => {
          //reject(error);
        });
    });
  }

  userEditMoneyTransferFun() {
    
    let transaction_type = "";
    if (this.state.popType == "CTB") {
      transaction_type = "Deposit";
    } else if (this.state.popType == "BTC") {
      transaction_type = "Withdraw";
    }else if (this.state.popType == "ADB") {
      transaction_type = "Adjust Bank";
    }
    var saleData = new FormData();
    saleData.append("bank_transction_id", this.props.accountTrasactionId);
    saleData.append("businessId", this.state.businessId);
    saleData.append("userId", this.state.userId);
    saleData.append("company_id", this.state.company_id);
    saleData.append("accountId", this.state.activeBankId);
    saleData.append("transaction_type", transaction_type);
    saleData.append("transfer_date", this.state.transfer_date);
    saleData.append("via", this.state.popType);
    saleData.append("deposit_to", this.state.deposit_to);
    saleData.append("withdraw_from", this.state.withdraw_from);
    saleData.append("amount", this.state.amount);
    saleData.append("bankId_AC", this.state.bankId_AC);
    saleData.append("bankName_AC", this.state.bankName_AC);
    saleData.append("adjust_type", this.state.adjust_type);
    saleData.append("description", this.state.description);
    saleData.append("descImage", this.state.descImage);

    
    if(this.state.popType == "ADB"){
      saleData.append("bankId_W", 0);
      saleData.append("bankName_W","");
      saleData.append("bankName_D", "");
      saleData.append("bankId_D", 0);
      saleData.append("account_name", "");
    }else{
      saleData.append("bankId_W", this.state.bankId_W);
      saleData.append("bankName_W", this.state.bankName_W);
      saleData.append("bankName_D", this.state.bankName_D);
      saleData.append("bankId_D", this.state.bankId_D);
      saleData.append("account_name", this.state.account_name);
    }
    //return false;
    //alert(this.state.transfer_date)

    new Promise((resolve, reject) => {
      fetch(global.userEditMoneyTransfer, {
        method: "POST",
        body: saleData,
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success == true) {
            sendNotification("Success Message 👍", res.message, "success");
            setTimeout(() => {
              this.props.callBack("hello");
              //window.location.href = global.webUrl+'business/sale-invoice/';
            }, Math.floor(Math.random() * 5000) + 1);
          } else {
            sendNotification("Error Message 😓", res.message, "danger");
            return;
          }
        })
        .catch((error) => {
          //reject(error);
        });
    });
  }

  onChangeFileUploadHandler = (event) => {
    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        descImage: file,
        imagePreviewUrl: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  previewImagesListing() {
    if (this.state.isLoaded == true) {
      let dataList = [];
      let _imageDetails = this.state.imagePreviewUrl;
      if (_imageDetails!="") {
        dataList.push(
          <img
            style={{ width: "35px" }}
            className="preview"
            src={_imageDetails}
            alt={"image-"}
            key="13213"
          />
        );
      }
      return dataList;
    }
  }

  isWithdrawDepositRadioType() {
    if (this.state.popType == "CTB") {
      return (
        <div className="col-6">
          <div className="form-material open">
            <input
              type="radio"
              required="required"
              id="depositTypee"
              name="depositType"
              value="Deposit"
              checked={this.state.depositType == "Deposit" ? "checked" : ""}
              defaultChecked
              onChange={this.onRadioChange}
            />
            &nbsp;&nbsp;Deposit&nbsp;&nbsp;
            <input
              type="radio"
              required="required"
              id="withdrawType"
              name="depositType"
              value="Withdraw"
              checked={this.state.depositType == "Withdraw" ? "checked" : ""}
              onChange={this.onRadioChange}
            />
            &nbsp;&nbsp;Withdraw&nbsp;&nbsp;
          </div>
        </div>
      );
    } else if (this.state.popType == "BTC") {
      return (
        <div className="col-6">
          <div className="form-material open">
            <input
              type="radio"
              required="required"
              id="depositTypee"
              name="depositType"
              value="Deposit"
              checked={this.state.depositType == "Deposit" ? "checked" : ""}
              onChange={this.onRadioChange}
              defaultChecked
            />
            &nbsp;&nbsp;Deposit&nbsp;&nbsp;
            <input
              type="radio"
              required="required"
              id="withdrawType"
              name="depositType"
              value="Withdraw"
              checked={this.state.depositType == "Withdraw" ? "checked" : ""}
              onChange={this.onRadioChange}
            />
            &nbsp;&nbsp;Withdraw&nbsp;&nbsp;
          </div>
        </div>
      );
    }
  }

  isWithdrawDepositType() {
    const { errors } = this.state;

    if (this.state.popType == "CTB") {
      // && this.state.depositType == 'Deposit'
      return (
        <div className="form-group row">
          <div className="col-6">
            <div className="form-material open">
              <select
                className="col-8 form-control"
                value={
                  this.state.bankId_D > 0
                    ? this.state.bankId_D
                    : this.state.deposit_to
                }
                id="deposit_to"
                name="deposit_to"
                onChange={this.handleChange}
              >
                {this.settleAmountTypeDeposit()}
              </select>
              <label htmlFor="login-username">Deposit To</label>
              <span className="iris_error_txt">
                {errors.deposit_to.length > 0 && (
                  <span className="error">{errors.deposit_to}</span>
                )}
              </span>
            </div>
          </div>
          <div className="col-6">
            <div className="form-material open">
              <input
                type="text"
                required="required"
                className="form-control"
                id="withdraw_from"
                name="withdraw_from"
                value="Cash"
                placeholder="Enter withdraw from"
                onChange={this.handleChange}
              />
              <label htmlFor="login-username">Withdraw From</label>
              <span className="iris_error_txt">
                {errors.withdraw_from.length > 0 && (
                  <span className="error">{errors.withdraw_from}</span>
                )}
              </span>
            </div>
          </div>
        </div>
      );
    } else if (this.state.popType == "BTC") {
      return (
        <div className="form-group row">
          <div className="col-6">
            <div className="form-material open">
              <input
                type="text"
                required="required"
                className="form-control"
                id="deposit_to"
                name="deposit_to"
                value="Cash"
                placeholder="Enter Amount"
                onChange={this.handleChange}
              />
              <label htmlFor="login-username">Deposit To</label>
              <span className="iris_error_txt">
                {errors.deposit_to.length > 0 && (
                  <span className="error">{errors.deposit_to}</span>
                )}
              </span>
            </div>
          </div>
          <div className="col-6">
            <div className="form-material open">
              <select
                  value={
                    this.state.bankId_W > 0
                        ? this.state.bankId_W
                        : this.state.withdraw_from
                  }
                name="withdraw_from"
                id="withdraw_from"
                className="form-control"
                onChange={this.handleChange}
              >
                {this.settleAmountType_WAk()}
              </select>
              <label htmlFor="login-username">Withdraw From</label>
              <span className="iris_error_txt">
                {errors.withdraw_from.length > 0 && (
                  <span className="error">{errors.withdraw_from}</span>
                )}
              </span>
            </div>
          </div>
        </div>
      );
    } else if (this.state.popType == "BTB") {
      return (
        <div className="form-group row">
          <div className="col-6">
            <div className="form-material open">
              <select
                className="col-8 form-control"
                defaultValue={
                  this.state.bankId > 0
                    ? this.state.bankId
                    : this.state.deposit_to
                }
                id="deposit_to"
                name="deposit_to"
                onChange={this.handleChange}
              >
                {this.settleAmountTypeDeposit()}
              </select>
              <label htmlFor="login-username">Deposit To</label>
              <span className="iris_error_txt">
                {errors.deposit_to.length > 0 && (
                  <span className="error">{errors.deposit_to}</span>
                )}
              </span>
            </div>
          </div>
          <div className="col-6">
            <div className="form-material open">
              <select
                className="col-8 form-control"
                defaultValue={
                  this.state.defaultBankId_W > 0
                    ? this.state.defaultBankId_W
                    : this.state.withdraw_from
                }
                id="withdraw_from"
                name="withdraw_from"
                onChange={this.handleChange}
              >
                {this.settleAmountType_WAk()}
              </select>
              <label htmlFor="login-username">Withdraw From</label>
              <span className="iris_error_txt">
                {errors.withdraw_from.length > 0 && (
                  <span className="error">{errors.withdraw_from}</span>
                )}
              </span>
            </div>
          </div>
        </div>
      );
    } else if (this.state.popType == "ADB") {
      let incSel = "";
      let redSel = "";
      if (this.state.adjust_type == "Increase") {
        incSel = "selected";
        redSel = "";
      } else {
        incSel = "";
        redSel = "selected";
      }
      return (
        <div className="form-group row">
          <div className="col-6">
            <div className="form-material open">
              <select
                name="adjust_type"
                id="adjust_type"
                className="form-control"
                onChange={this.handleChange}
              >
                <option value="Increase" selected={incSel}>
                  Increase Balance
                </option>
                <option value="Reduce" selected={redSel}>
                  Reduce Balance
                </option>
              </select>
              <label htmlFor="login-username">Type </label>
            </div>
          </div>
          <div className="col-6">
            <div className="form-material open">
              <select
                className="col-8 form-control"
                defaultValue={
                  this.state.bankId > 0
                    ? this.state.bankId
                    : this.state.deposit_to
                }
                id="account_name"
                name="account_name"
                onChange={this.handleChange}
              >
                {this.settleAmountTypeADB()}
              </select>
              <label htmlFor="login-username">Account Name</label>
            </div>
          </div>
        </div>
      );
    }
  }

  isDateRefresh = () => {
    const slectedDate = moment(this.state.transfer_date).toDate();
    return (
      <DatePicker
        selected={slectedDate}
        className="form-control search-box"
        onChange={date => this.setState({ transfer_date: moment(date).format("YYYY-MM-DD") })}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
      />
    );
  };

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }

    const { errors } = this.state;
    const isDisabled = Object.keys(errors).some((x) => errors[x]);
    return (
      <React.Fragment>
        <form method="post" id="form-login" className="webForm px-30">
          <div className="form-group row">
            {this.isWithdrawDepositRadioType()}
            <div className="col-6">
              <div className="form-material open">
                {this.isDateRefresh()}
                <label htmlFor="login-username">Transfer Date</label>
              </div>
            </div>
          </div>
          <div className="claerfix"></div>
          {this.isWithdrawDepositType()}
          <div className="claerfix"></div>
          <div className="form-group row">
            <div className="col-6">
              <div className="form-material open">
                <input
                  type="text"
                  required="required"
                  className="form-control"
                  id="amount"
                  name="amount"
                  value={this.state.amount}
                  placeholder="Enter Amount"
                  onChange={this.handleChange}
                />
                <label htmlFor="login-username">
                  Enter Amount <span className="text-danger">*</span>
                </label>
                <span className="iris_error_txt">
                  {errors.amount.length > 0 && (
                    <span className="error">{errors.amount}</span>
                  )}
                </span>
              </div>
            </div>
            <div className="col-6">
              <div className="form-material open">
                <textarea
                  name="description"
                  id="description"
                  placeholder="Enter Description"
                  className="form-control"
                  onChange={this.handleChange}
                  value={this.state.description}
                  rows="1"
                ></textarea>
                <label htmlFor="login-username">
                  Enter Description (Optional)
                </label>
              </div>
            </div>
          </div>

          <div className="claerfix"></div>
          <div className="form-group row">
            <div className="col-6">
              <label htmlFor="login-username">Attach Image (Optional)</label>
              <div className="form-material open">
                <input
                  type="file"
                  accept="image/*"
                  onChange={this.onChangeFileUploadHandler}
                  name="item_image"
                />
              </div>
              <div>
                {this.previewImagesListing()}
                {/* {this.previewOldImagesListing()} */}
              </div>
            </div>
          </div>

          <div className="claerfix"></div>
          <div className="form-group row">
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-alt-primary"
                onClick={this.clickToAddBankDetails}
                disabled={isDisabled}
              >
                <i className="fa fa-check mr-5"></i> Save
              </button>
            </div>
          </div>
        </form>

        {/* Modal Add Bank Details Begins */}
        <Modal
          isOpen={this.state.modalIsOpen_SBANK}
          ariaHideApp={false}
          size="sm"
          aria-labelledby="modal-popout"
          onRequestClose={this.closeModalHandler}
          id="modalAdjustNewBank"
        >
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="block block-themed block-transparent mb-0">
                <div className="block-header bg-primary-dark">
                  <h3 className="block-title">Add New Bank</h3>
                  <div className="block-options">
                    <button
                      type="button"
                      className="btn-block-option"
                      onClick={this.closeModalHandler.bind(
                        this,
                        "modalAdjustNewBank"
                      )}
                    >
                      <i className="si si-close"></i>
                    </button>
                  </div>
                </div>
                <div className="block-content">
                  <QuickAddNewBankDetail
                    callBack={() => {
                      this.closeModalHandler("modalAdjustNewBank");
                      this.getBankAccListData();

                  }} 
                  />
                </div>
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-alt-secondary"
                  onClick={this.closeModalHandler.bind(
                    this,
                    "modalAdjustNewBank"
                  )}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {/* Modal Add Bank Details*/}
      </React.Fragment>
    );
  }
}
